import { ReactNode } from "react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";

interface NeumorphicModelImageProps {
  children: ReactNode;
  className?: string;
}

const NeumorphicModelImage = ({ children, className = "" }: NeumorphicModelImageProps) => {
  let theme = "dark";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }

  const getStyles = () => {
    if (theme === "dark") {
      return "bg-[#0a0a0a] shadow-[12px_12px_24px_#000000,-12px_-12px_24px_#0d0d0d]";
    } else {
      return "bg-[#f5f5f5] shadow-[12px_12px_24px_#d8d8d8,-12px_-12px_24px_#fefefe]";
    }
  };

  return (
    <div className={cn(
      "rounded-xl overflow-hidden transition-all duration-300",
      getStyles(),
      className
    )}>
      {children}
    </div>
  );
};

export default NeumorphicModelImage;
